<template>
    <div class="box">
        <b-card>
            <!--form Data-->
            <ag-grid-vue style="height: 500px" class="ag-theme-alpine" :gridOptions="gridOptions"
                         :rowSelection="rowSelection" :columnDefs="columnDefs" :rowData="caseData"
                         @cellClicked="cellClicked($event)"
                         :defaultColDef="defaultColDef"
                         :frameworkComponents="frameworkComponents"
                         :animateRows="true" :pagination="true"
                         :suppressPaginationPanel="true" :suppressRowClickSelection="true">
            </ag-grid-vue>
        </b-card>
    </div>
</template>

<script>
    import $ from 'jQuery';
    import {AgGridVue} from "ag-grid-vue";
    import TranslationCellRenderer from '../../../common/plugins/TranslationCellRenderer'   //翻译
    export default {
        name: "agGridForm",
        props: {tabs: {},},
        components: {AgGridVue,},
        data() {
            return {
                gridOptions: {},
                rowSelection: null,
                columnDefs: '',
                frameworkComponents: {agColumnHeader: TranslationCellRenderer},
                gridApi: null,
                totalRow:'',
                tabIndex: 0,
                tabIndex2: 0,
                tabCounter:0,
                defaultColDef: {
                    sortable: true, //开启排序
                    filter: true  //开启刷选
                },
                caseData2:[]
            }
        },
        beforeMount() {
            this.columnDefs = [];
            this.caseData = [];
            this.rowSelection = "multiple";
        },
        methods: {
            getCaseData(){
                this.caseData = [
                    {
                        "clientId": "1",
                        "objTitle": "data01",
                        "shortName": "Short Name(简称)",
                        "objDesc": "Description",
                        "salesName": "Sales",
                        "address1": "Address 1",
                        "address2": "Address 2",
                        "tele": "Telephone "
                    },
                    {
                        "clientId": "2",
                        "objTitle": "data02",
                        "shortName": "Short Name(简称)",
                        "objDesc": "Description",
                        "salesName": "Sales",
                        "address1": "Address 1",
                        "address2": "Address 2",
                        "tele": "Telephone "
                    },
                    {
                        "clientId": "2",
                        "objTitle": "data03",
                        "shortName": "Short Name(简称)",
                        "objDesc": "Description",
                        "salesName": "Sales",
                        "address1": "Address 1",
                        "address2": "Address 2",
                        "tele": "Telephone "
                    },
                    {
                        "clientId": "4",
                        "objTitle": "data04",
                        "shortName": "Short Name(简称)",
                        "objDesc": "Description",
                        "salesName": "Sales",
                        "address1": "Address 1",
                        "address2": "Address 2",
                        "tele": "Telephone "
                    }
                ]
            },
            //点击单元格
            cellClicked(e) {
                if (e.colDef.field === "clientId") {
                    this.$emit('tabsData', e.data.clientId);
                    var tabName = e.data.objTitle;
                    var tabId = e.data.clientId;
                    var isExists = false;
                    for (let i = 0; i < this.tabs.length; i++) {
                        if (this.tabs[i].id === tabId) {
                            isExists = true;
                            this.tabIndex = this.tabs[i].i;
                            this.$emit('tabIndex', this.tabIndex + 1);
                        }
                    }
                    if (isExists === false) {
                        this.$emit('tabIndex', this.tabIndex2);
                        this.tabs.push({title: tabName, id: tabId, i: this.tabCounter++, index: this.tabIndex2++});
                    }
                }
            },

        },
        mounted() {

            this.gridApi = this.gridOptions.api;
            this.gridApi.sizeColumnsToFit();//调整表格大小自适应
            this.$axios.get("./company/columnDefs.json").then(response => {
                this.columnDefs = response.data.columnDefs; //ag form head
            });
            this.getCaseData()
        },
    }
</script>

